// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3yCXqTa9","list":"_1GISQinX","item":"_2R81DZ9l","divider":"X7cEb6Rr"};